import script from "./RequisitionPOList.vue?vue&type=script&setup=true&lang=js"
export * from "./RequisitionPOList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__